import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../../../core/config/api-endpoints.constants';
import { createCatalogueStore } from '../../catalogue/catalogue-store.util';
import type { CatalogueStore } from '../../catalogue/catalogue.types';
import { Weapon, WeaponCreate, WeaponUpdate } from '../models/weapon.model';

@Injectable({ providedIn: 'root' })
export class WeaponStoreService implements CatalogueStore<Weapon, WeaponCreate, WeaponUpdate> {
  private readonly store = createCatalogueStore<Weapon, WeaponCreate, WeaponUpdate>({
    endpoint: API_ENDPOINTS.weapons,
    uploadPath: '/api/weapons/upload_image',
  });

  weaponsResource = this.store.resource;
  items = this.store.items;
  loading = this.store.loading;
  error = this.store.error;
  byId = this.store.byId;
  reload = this.store.reload;

  create = this.store.create;
  update = this.store.update;
  remove = this.store.remove;
  uploadImage = this.store.uploadImage;

  createWeapon = this.store.create;
  updateWeapon = this.store.update;
  deleteWeapon = this.store.remove;
}
